module.exports = __webpack_public_path__ + "img/ic_chat_btn_chat.da096bf8.svg";